//
// Javascript for the DateEdit input control
//
//  Ben Ramey
//  March 2010
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.InfobarWidgets = function () {
  this.widgets = $("li.infobar-widget");

  if (this.widgets.length == 0) {
    return;
  }

  this.onLoadMenu = new HEIJS.Event();
  this.onOpenWidget = new HEIJS.Event();
  this.onCloseWidget = new HEIJS.Event();
  this.setupEvents();
};

HEIJS.Controls.InfobarWidgets.prototype =
{
  //
  // Properties
  //
  widgets: null,
  loadingSpin: {
    lines: 13, // The number of lines to draw
    length: 0, // The length of each line
    width: 5, // The line thickness
    radius: 14, // The radius of the inner circle
    corners: 1, // Corner roundness (0..1)
    rotate: 0, // The rotation offset
    color: '#566c11', // #rgb or #rrggbb
    speed: 1.2, // Rounds per second
    trail: 60, // Afterglow percentage
    shadow: false, // Whether to render a shadow
    hwaccel: false, // Whether to use hardware acceleration
    className: 'spinner', // The CSS class to assign to the spinner
    zIndex: 2e9, // The z-index (defaults to 2000000000)
    top: '14px', // Top position relative to parent in px
    left: 'auto' // Left position relative to parent in px
  },

  // events
  onLoadMenu: null,
  onOpenWidget: null,
  onCloseWidget: null,


  //
  // Methods
  //
  showFlyout: function (widget) {
    var flyout = widget.find("div.infobar-flyout,div.infobar-widget-menu");
    if (flyout.is(":visible")) {
      return;
    }

    var self = this;
    var classes = "infobar-widget-selected";

    if (flyout.parents("li.infobar-widget").hasClass("infobar-widget-splitbtn")) {
      classes += " infobar-widget-splitbtn-selected";
    }

    if (!flyout.is(":visible")) {
      var $top = widget.parents('div.top');
      if ($top.length > 0 &&
        !flyout.hasClass('infobar-widget-menu')) {
        if (flyout.prev('.infobar-widget-arrow,.infobar-widget-arrowborder').length <= 0) {
          $('<div></div>').addClass('infobar-widget-arrow').insertBefore(flyout);
          $('<div></div>').addClass('infobar-widget-arrowborder').insertBefore(flyout);
        }
        if (widget.parents('.layertwo-nav-wrapper').length > 0) $top.css('z-index', '9998');
        else $top.css('z-index', '');
        self.toggleOverlay(true);
      }

      flyout
        .show()
        .attr({ 'title': $.browser.msie ? '' : ' ' }) // workaround to not display the title of the parent widget element when mousing over the flyout
        .children("div.scroller-top").css("visibility", "hidden")
        .siblings("div.scroller-bottom").css("visibility", "visible")
        .siblings("ul")
          .scrollTop(0);
      flyout.prevAll('.infobar-widget-arrow,.infobar-widget-arrowborder').show();

      setTimeout(function () { self.onOpenWidget.Trigger(); }, 10); // triger open event
    }

    flyout.parents("li.infobar-widget").addClass(classes);

    if (flyout[0].__sized != true) {
      var menuWidth = flyout.width(); // SP-149
      var menuHeight = flyout.height();
      var pageSpace = $(window).height() - flyout.offset().top - $("div.bottom").height();

      if (menuHeight >= pageSpace) {
        flyout[0].__sized = true;
        flyout
          .attr("sized", true)
          .prepend("<div class='scroller-top'><span class='ui-icon ui-icon-carat-1-n'></span></div>")
          .append("<div class='scroller-bottom'><span class='ui-icon ui-icon-carat-1-s'></span></div>")
          .children("ul")
            .height(pageSpace - 25)
            .css("overflow", "hidden");
      }
    }
    else if (flyout[0].__doResize == true) {
      flyout[0].__doResize = false;
      flyout.children("ul").css("height", "auto");

      var menuHeight = flyout.height();
      var pageSpace = $(window).height() - flyout.offset().top - $("div.bottom").height();

      if (menuHeight >= pageSpace)
        flyout.children("ul").height(pageSpace - 25);
      else {
        flyout
          .children("div.scroller-top").css("visibility", "hidden")
          .siblings("div.scroller-bottom").css("visibility", "hidden");
      }
    }

    setTimeout(
      function () {
        $(document).unbind('mousedown.infobarflyoutwindow').bind("mousedown.infobarflyoutwindow", function (e) {
          self.hideFlyout(e, widget);
        });
        $("iframe").each(function () {
          try {
            $(this.contentWindow.document).unbind('mousedown.infobarflyoutwindow').bind("mousedown.infobarflyoutwindow", function (e) {
              self.hideFlyout(e, widget);
            });
          }
          catch (e) { }
        });
      },
      100
    );

    var $loadingMsg = widget.find("div.loading-message");
    if ($loadingMsg.length > 0 && $loadingMsg.is(":visible")) {
      // start loading
      if (!$loadingMsg.attr("loading")) {
        $loadingMsg.attr("loading", "1");
        var loader = $('<div></div>').addClass('infobar-flyout-loadingmessag-spinner').appendTo($loadingMsg);
        loader.heiOverlay({ 'overlay': { 'opacity': 1 }, 'spinner': { 'height': '40px' }, 'delay': 0 });

        var args = { 'widget': widget };
        if (widget.attr('onLoadMenuHandlerKey')) {
          args['key'] = parseInt(widget.attr('onLoadMenuHandlerKey'));
        }
        setTimeout(function () { self.onLoadMenu.Trigger(args); }, 10);
      }
    }
  },

  hideFlyout: function (e, widget) {
    var self = this;
    if (widget.is($(e.target).parents('li.infobar-widget').first())) return;

    setTimeout(function () {
      var flyout = widget.find("div.infobar-flyout,div.infobar-widget-menu");
      var target = $(e.target);

      if ($('div.select2-drop-mask:visible').length == 0 &&
        ((!target.is("div.infobar-flyout") && target.parents("div.infobar-flyout").length == 0 &&
          target.parents(".ui-dialog,.infobar-flyout-temporary").length == 0 && $('.ui-dialog:visible').length == 0 && !target.hasClass('infobar-flyout-temporary')))) {
        //|| target.is(".button,.small-button") || target.parents(".button,.small-button").length > 0

        flyout.hide().prevAll('.infobar-widget-arrow,.infobar-widget-arrowborder').hide();
        if ($("div.infobar-flyout").length > 0 && !$("div.infobar-flyout").is(':visible')) self.toggleOverlay(false);
        widget.parents('.top').first().css('z-index', '');
        flyout.parents("li.infobar-widget").removeClass("infobar-widget-selected infobar-widget-splitbtn-selected");

        setTimeout(function () { self.onCloseWidget.Trigger(); }, 10); // triger close event
      }
    }, 50);
  },

  toggleOverlay: function (display) {
    var $io = $('.infobar-overlay');
    if (display) {
      if ($io.length > 0) $('.infobar-overlay').first().fadeIn(500);
      else {
        $io = $('<div></div>').addClass('infobar-overlay').appendTo('body');
        $io.fadeIn(500);
      }
    } else $('.infobar-overlay').remove();
  },

  setupEvents: function () {
    var self = this;

    $(window).bind("resize.infobarwidgetmenus", function () {
      $("div.infobar-widget-menu[sized=true]").each(function (i, d) { d.__doResize = true; });
    });

    this.widgets
      .hover(
        function () { $(this).addClass("infobar-widget-hover"); },
        function () { $(this).removeClass("infobar-widget-hover"); }
      )
      .filter(":not(li.infobar-widget-splitbtn):has(div.infobar-flyout,div.infobar-widget-menu)")
      .click(function (e) { self.showFlyout($(this)); });

    // all split buttons have a flyout, that's why they have a split button
    // so we don't need to filter on :has(div.infobar-flyout)
    this.widgets.filter("li.infobar-widget-splitbtn")
      .hover(
        function () { $(this).addClass("infobar-widget-splitbtn-hover"); },
        function () { $(this).removeClass("infobar-widget-splitbtn-hover"); }
      )
      .find("span.icon-wrapper")
      .hover(
        function () { $(this).addClass("icon-wrapper-hover"); },
        function () { $(this).removeClass("icon-wrapper-hover"); }
      )
      .click(function (e) { self.showFlyout($(this).parent()); });
  }
};

$(document).ready(
  function () {
    HEIJS.infobarWidgets = new HEIJS.Controls.InfobarWidgets();
  });